import * as React from "react"

const DownloadSVG = (props) => (
	<svg width={20} height={17} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M0 10h2v5h16v-5h2v5c0 1.11-.89 2-2 2H2a2 2 0 0 1-2-2v-5Zm10 3 5.55-5.46-1.42-1.41L11 9.25V0H9v9.25L5.88 6.13 4.46 7.55 10 13Z"
			fill="#475163"
		/>
	</svg>
)

export default DownloadSVG
